module.exports = __webpack_public_path__ + "img/demoOne.b2c1da68.png";